
export const SAMPLE_TYPE_SUFFIXES = {
  SERUM: 's',
  PLASMA: 'p',
  URINE: 'u',
};

// M-Codes that require suffix in accession ID
export const M_CODES_REQUIRING_SUFFIX = [
  'c-series',
  'i-series',
  'AU680',
  'DXI600',
  'DXI-600',
  'PLASMA',
  'URINE',
  // 'LAVENDER', // Uncomment if needed
];

// CA600 instrument m-codes
export const M_CODES_CA600 = [
  'CA600',
  'CA-600',
];

// M-Codes display rules
export const M_CODE_DISPLAY_RULES = {
  // When m_code contains these, display "c-series"
  URINE_PLASMA_CODES: ['urine', 'plasma'],
  URINE_PLASMA_DISPLAY: 'c-series',
  
  // When m_code contains both i-series and c-series
  I_SERIES: 'i-series',
  C_SERIES: 'c-series',
  COMBINED_DISPLAY: 'i-series, c-series',
};


export const shouldApplySuffix = (mCode) => {
  const mCodeString = Array.isArray(mCode) ? mCode.join(', ') : (mCode || '');
  const code = mCodeString?.toLowerCase() || '';
  const codeRaw = mCodeString?.trim();
  
  return M_CODES_REQUIRING_SUFFIX.some(requiredCode => {
    const requiredLower = requiredCode.toLowerCase();
    return code.includes(requiredLower) || codeRaw.toUpperCase() === requiredCode.toUpperCase();
  });
};


export const isCA600MCode = (mCode) => {
  const mCodeString = Array.isArray(mCode) ? mCode.join(', ') : (mCode || '');
  const codeUpper = mCodeString?.toUpperCase() || '';

  return M_CODES_CA600.some(code => codeUpper.includes(code));
};

export const getSampleTypeSuffix = (sampleType) => {
  const type = (sampleType || '').toLowerCase();
  
  if (type.includes('serum')) return SAMPLE_TYPE_SUFFIXES.SERUM;
  if (type.includes('plasma')) return SAMPLE_TYPE_SUFFIXES.PLASMA;
  if (type.includes('urine')) return SAMPLE_TYPE_SUFFIXES.URINE;
  
  return null; // No suffix for unmatched types
};

/**
 * Extract first alphabetic characters from code
 * @param {string} code - The code to process
 * @returns {string}
 */
export const extractCodePrefix = (code) => {
  const trimmedCode = code.trim();
  const match = trimmedCode.match(/^([A-Za-z]+)/);
  return match ? match[1].toUpperCase() : trimmedCode.substring(0, 2).toUpperCase();
};

export const DOUBLE_C_PREFIX_ACCESSIONS = new Set([
  "TDC261012216",
  "TDC261012226",
  "TDC261013037",
  "TDC261013040",
  "TDC261013041",
  "TDC261013043",
  "TDC261013045",
  "TDC261013050",
  "TDC261013051",
  "TDC261013063",
  "TDC261013064",
  "TDC261013065",
  "TDC261013067",
  "TDC261013068",
  "TDC261013072",
  "TDC261013073",
  "TDC261013079",
  "TDC261013080",
  "TDC261013081",
  "TDC261013082",
  "TDC261013090",
  "TDC261013093",
  "TDC261013095",
  "TDC261013099",
  "TDC261013100",
  "TDC261013101",
  "TDC261013104",
  "TDC261013105",
  "TDC261013107",
  "TDC261013108",
  "TDC261013109",
  "TDC261013114",
  "TDC261013115",
  "TDC261013117",
  "TDC261013119",
  "TDC261013120",
  "TDC261013121",
  "TDC261013124",
  "TDC261013125",
  "TDC261013130",
  "TDC261013132",
  "TDC261013135",
  "TDC261013143",
  "TDC261013149",
  "TDC261013150",
  "TDC261013153",
  "TDC261013165",
  "TDC261013166",
  "TDC261013175",
  "TDC261013176",
  "TDC261013178",
  "TDC261013179",
  "TDC261013181",
  "TDC261013182",
  "TDC261013186",
  "TDC261013191",
  "TDC261013206",
  "TDC261013213",
  "TDC261013214",
  "TDC261013221",
  "TDC261013222",
  "TDC261009078",
  "TDC261009186",
  "TDC261010025",
  "TDC261010031",
  "TDC261010033",
  "TDC261010052",
  "TDC261010065",
  "TDC261012096",
  "TDC261012128",
  "TDC261012131",
  "TDC261012196",
  "TDC261012213",
  "TDC261012214",
  "TDC261012215",
  "TDC261012217",
  "TDC261012220",
  "TDC261012222",
  "TDC261012223",
  "TDC261012224",
  "TDC261012225",
  "TDC261012227",
  "TDC261012228",
  "TDC261012229",
  "TDC261012230",
  "TDC261012232",
  "TDC261012233",
  "TDC261012235",
  "TDC261012236",
  "TDC261012237",
  "TDC261012238",
  "TDC261012239",
  "TDC261012241",
  "TDC261012242",
  "TDC261012243",
  "TDC261012246",
  "TDC261012247",
  "TDC261012249",
  "TDC261012250",
  "TDC261012251",
  "TDC261012253",
  "TDC261012257",
  "TDC261012258",
  "TDC261012260",
  "TDC261012261",
  "TDC261012262",
  "TDC261012263",
  "TDC261012264",
  "TDC261012265",
  "TDC261012266",
  "TDC261012267",
  "TDC261012268",
  "TDC261012269",
  "TDC261012271",
  "TDC261012272",
  "TDC261012274",
  "TDC261012275",
  "TDC261012276",
  "TDC261012278",
  "TDC261012280",
  "TDC261013001",
  "TDC261013003",
  "TDC261013004",
  "TDC261013006",
  "TDC261013007",
  "TDC261013008",
  "TDC261013009",
  "TDC261013011",
  "TDC261013012",
  "TDC261013013",
  "TDC261013014",
  "TDC261013015",
  "TDC261013017",
  "TDC261013018",
  "TDC261013019",
  "TDC261013020",
  "TDC261013021",
  "TDC261013022",
  "TDC261013023",
  "TDC261013024",
  "TDC261013025",
  "TDC261013027",
  "TDC261013028",
  "TDC261013029",
  "TDC261013030",
  "TDC261013031",
  "TDC261013032",
  "TDC261013033",
  "TDC261013036",
  "TDC261013038",
  "TDC261013039",
  "TDC261013042",
  "TDC261013044",
  "TDC261013046",
  "TDC261013047",
  "TDC261013048",
  "TDC261013052",
  "TDC261013053",
  "TDC261013069",
  "TDC261013070",
  "TDC261013071",
  "TDC261013074",
  "TDC261013076",
  "TDC261013077",
  "TDC261013083",
  "TDC261013084",
  "TDC261013086",
  "TDC261013087",
  "TDC261013088",
  "TDC261013091",
  "TDC261013096",
  "TDC261013097",
  "TDC261013102",
  "TDC261013103",
  "TDC261013118",
  "TDC261013122",
  "TDC261013126",
  "TDC261013128",
  "TDC261013133",
  "TDC261013136",
  "TDC261013140",
  "TDC261013141",
  "TDC261013142",
  "TDC261013144",
  "TDC261013155",
  "TDC261013156",
  "TDC261013157",
  "TDC261013158",
  "TDC261013159",
  "TDC261013161",
  "TDC261013162",
  "TDC261013167",
  "TDC261013174",
  "TDC261013177",
  "TDC261013180",
  "TDC261013183",
  "TDC261013184",
  "TDC261013185",
  "TDC261013187",
  "TDC261013188",
  "TDC261013190",
  "TDC261013192",
  "TDC261013193",
  "TDC261013194",
  "TDC261013195",
  "TDC261013196",
  "TDC261013197",
  "TDC261013198",
  "TDC261013199",
  "TDC261013201",
  "TDC261013202",
  "TDC261013215",
  "TDC261013217",
  "TDC261013218",
  "TDC261013219",
  "TDC261013226",
  "TDC261013227",
  "TDC261013229",
  "TDC261013231",
  "HCC261012054",
  "HCC261012142",
  "HCC261012143",
  "HCC261012144",
  "HCC261012145",
  "HCC261012146",
  "HCC261012147",
  "HCC261012149",
  "HCC261013001",
  "HCC261013002",
  "HCC261013003",
  "HCC261013005",
  "HCC261013006",
  "HCC261013007",
  "HCC261013008",
  "HCC261013009",
  "HCC261013014",
  "HCC261013015",
  "HCC261013032",
  "HCC261013036",
  "HCC261013055",
  "HCC261013056",
  "HCC261013057",
  "HCC261013058",
  "HCC261013064",
  "HCC261013066",
  "HCC261013093",
  "HCC261013094",
  "HCC261013095",
  "HCC261013096",
])

/**
 * Barcode accession value: adds the extra "C" for listed TDC / HCC accessions.
 * @param {string} accessionId
 * @returns {string}
 */
export const getBarcodeAccession = (accessionId) => {
  if (!accessionId || !DOUBLE_C_PREFIX_ACCESSIONS.has(accessionId)) {
    return accessionId;
  }
  return accessionId.replace(/^(TDC|HCC)/, "$1C");
};

export default {
  SAMPLE_TYPE_SUFFIXES,
  M_CODES_REQUIRING_SUFFIX,
  M_CODES_CA600,
  M_CODE_DISPLAY_RULES,
  shouldApplySuffix,
  isCA600MCode,
  getSampleTypeSuffix,
  extractCodePrefix,
  DOUBLE_C_PREFIX_ACCESSIONS,
  getBarcodeAccession,
};
